export default {
  navigationBarTitleText: '邀请记录'
};
